import { sortByLabelAsc } from "util/sort-by-prop";

function getTargetDevice(device, isDisabled = false) {
  const { id, name, device_id: deviceId } = device;

  return {
    isDisabled,
    label: `device: ${name} (${deviceId})`,
    value: `d_${id}`,
  };
}

function getTargetTag(tag, isDisabled = false) {
  const { id, name } = tag;

  return {
    isDisabled,
    label: `tag: ${name}`,
    value: `t_${id}`,
  };
}

function _extractTargets(devices, isDisabled) {
  return Object.values(devices).reduce((acc, device) => {
    const { tags = [] } = device;
    const target = getTargetDevice(device, isDisabled);
    acc[target.value] = target;

    tags.forEach((tag) => {
      const target = getTargetTag(tag, isDisabled);
      acc[target.value] = target;
    });

    return acc;
  }, {});
}

/**
 * Builds an array of select options for device targets.
 *
 * @param {Object} devices - a device byId object.
 * @param {Object} deletedDevices - a deleted device byId object.
 * @return {Object[]} - Returns an array of select options.
 */
function getTargetOptions(devices = {}, deletedDevices = {}) {
  const deviceTargets = _extractTargets(devices, false);
  const deletedDeviceTargets = _extractTargets(deletedDevices, true);

  const targets = {
    ...deviceTargets,
    ...deletedDeviceTargets,
  };

  return Object.values(targets)
    .map((target) => {
      const { isDisabled, label, value } = target;

      return {
        value,
        label,
        isDisabled,
      };
    })
    .sort(sortByLabelAsc);
}

export { getTargetOptions };
